import createIcon from "components/elements/Icons/create-icon";

export default createIcon("Calendar", [
  [
    "path",
    {
      d: "M15 3.5H15.5V3V2C15.5 1.72386 15.7238 1.5 16 1.5C16.2762 1.5 16.5 1.72386 16.5 2V3V3.5H17H19C20.3808 3.5 21.5 4.61929 21.5 6V10V20C21.5 21.3808 20.3808 22.5 19 22.5H5C3.61929 22.5 2.5 21.3808 2.5 20V10V6C2.5 4.61929 3.61929 3.5 5 3.5H7H7.5V3V2C7.5 1.72386 7.72386 1.5 8 1.5C8.27614 1.5 8.5 1.72386 8.5 2V3V3.5H9H15ZM20 9.5H20.5V9V6C20.5 5.17158 19.8284 4.5 19 4.5H17H16.5V5V6C16.5 6.27614 16.2762 6.5 16 6.5C15.7238 6.5 15.5 6.27614 15.5 6V5V4.5H15H9H8.5V5V6C8.5 6.27614 8.27614 6.5 8 6.5C7.72386 6.5 7.5 6.27614 7.5 6V5V4.5H7H5C4.17158 4.5 3.5 5.17158 3.5 6V9V9.5H4H20ZM4 10.5H3.5V11V20C3.5 20.8284 4.17158 21.5 5 21.5H19C19.8284 21.5 20.5 20.8284 20.5 20V11V10.5H20H4Z",
    },
  ],
]);
